import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, commsHeader } from '../../../../Containers/Config/index.js';
import { GET_TEMPLATE_LIST, GET_TEMPLATE_LIST_SUCCESS, GET_TEMPLATE_LIST_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getTemplateList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: payload.id ? `${indianProjectsBaseURL}/comms/templates/${payload.id}` : `${indianProjectsBaseURL}/comms/templates`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...commsHeader,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_TEMPLATE_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_TEMPLATE_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_TEMPLATE_LIST_ERROR, payload: error });
  }
}

export function* watchTemplateList() {
  yield takeEvery(GET_TEMPLATE_LIST, getTemplateList);
}

function* getTemplateListSaga() {
  yield all([fork(watchTemplateList)]);
}

export default getTemplateListSaga;
